import * as requestFromServer from "./UserGroupAuthorizationCrud";
import { userGroupAuthorizationSlice } from "./UserGroupAuthorizationSlice";

const {actions} = userGroupAuthorizationSlice;

export const getList = () => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAuthorities = userGroupId => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .getAuthorities(userGroupId)
    .then(response => {
      dispatch(actions.authoritiesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveAuthorities = (userGroupId, moduleAndAuthorities) => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .saveAuthorities(userGroupId, moduleAndAuthorities)
    .then(response => {
      dispatch(actions.authoritiesSaved());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const cleanAuthorities = () => dispatch => {
  dispatch(actions.authoritiesCleaned());
}